export enum SUMMARY_REPORT_FORM_FIELDS {
  CLIENT = "clientId",
  TO_DATE = "createDateLte",
  FROM_DATE = "createDateGte",
}
